import React from 'react';
import AnimateAvatarImage from "./AnimateAvatarImage";

interface TeamCardItemProps {
	imgId: string;
	name: string;
	post: string;
	description: string;
}

const TeamCardItem = (props: TeamCardItemProps) => {
	return (
		<div className="teamCardItem">
			<div className="teamCardItem__img">
				<AnimateAvatarImage imgId={props.imgId} />
			</div>
			<div className="teamCardItem__content">
				<div className="teamCardItem__content_name">
					<span>{props.name}</span>
				</div>
				<div className="teamCardItem__content_post">
					<span>{props.post}</span>
				</div>
				<div className="teamCardItem__content_description">
					<span>{props.description}</span>
				</div>
			</div>

		</div>
	);
};

export default TeamCardItem;